import script from "./PageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageModal.vue?vue&type=script&setup=true&lang=ts"

import "./PageModal.vue?vue&type=style&index=0&id=2294bfe3&scoped=true&lang=less"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2294bfe3"]])

export default __exports__